import { ImageCustom } from "../Image";
import { listUrl } from "../Data";

import {
  BannerWrapper,
  BannerBox,
  Title,
  Subtitle,
  Description,
  BannerImg,
} from "./style";

const BannerComponent = () => {
  return (
    <BannerWrapper id="Somos-a-Arezzo">
      <BannerBox>
        <Title>Somos a</Title>
        <Subtitle>Arezzo<span>&</span>Co.</Subtitle>
        <Description>Líder no setor de calçados, bolsas e acessórios femininos no brasil, com presença em todos os estados do país e atuação no exterior.  Se tornou a maior House of Brands expandindo sua atuação para o setor de vestuário, com um portfólio que reúne as marcas Arezzo, Schutz, Alexandre Birman, Anacapri, Fiever, Alme, Vans, Brizza, Reserva, Reserva Mini, Oficina, INK, TROC, Reserva Go, Baw Clothing, Reversa, Simples, My Shoes e Carol Bassi, além do marketplace ZZ’Mall.</Description>
        <Description>Interpretar tendências e despertar desejos é o que nos move. E buscamos fazer uma moda mais consciente, responsável e diversa para ser melhor PARA o mundo. Rumo à 2154! </Description>
      </BannerBox>
      <BannerImg>
        <Title>Somos a</Title>
        <Subtitle>Arezzo<span>&</span>Co.</Subtitle>
        <ImageCustom src={listUrl.banner.img} alt="" />
        <Description>Líder no setor de calçados, bolsas e acessórios femininos no Brasil, com presença em todos os estados do País e atuação no exterior. Durante os nossos quase 50 anos de história, movidos pela conexão e o desafio de encantar clientes, ampliamos nossos negócios e nos tornamos uma House of Brands, expandindo nossa atuação para o setor de vestuário, com um portfólio que hoje contempla 16 marcas e duas plataformas online de moda.</Description>
        <Description>Nossa trajetória é marcada pela força de adaptação e abertura para o novo, e esse caminho nos levou a assumir compromissos para uma boa gestão da sustentabilidade em nossas marcas, negócios e operações. Definimos nossos pilares através da revisão do posicionamento estratégico de sustentabilidade, e eles norteiam nossas ações, projetos e tomadas de decisões. </Description>
      </BannerImg>

    </BannerWrapper>
  );
};

export default BannerComponent;
